import React from 'react'
import { useTable, usePagination, useGlobalFilter } from "react-table"
import Select from 'react-select';

function TableCertificado({ columns, data, filterSelect, setSelectCurso, filterTipo, setSelectedTipo, setSelectUnidade, unidades, empresas = [], selectedEmpresa, setSelectedEmpresa, length = true, search = true, titulo = '' }) {

    const props = useTable(
        {
            columns,
            data: data,
            initialState: { pageSize: 20 }

        },
        useGlobalFilter,
        usePagination,
    );

    const {
        getTableBodyProps,
        rows,
        prepareRow,
        setGlobalFilter,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex, pageSize, globalFilter }
    } = props;

    const customStyles = {
        container: (base) => ({
            ...base,
            width: '100%',
        }),
        control: (base, state) => ({
            ...base,
            fontSize: "1rem",
            backgroundColor: "#ffffff",
            borderRadius: "0.25rem",
            boxShadow: state.isFocused ? "0 0 0 0.25rem #27485b73" : null,
            borderColor: "#dee2e6",
            "&:hover": {
                borderColor: "#dee2e6"
            },
        }),
        singleValue: (base) => ({
            ...base,
            color: '#000',
            marginTop: '5px',
        }),
        input: (base) => ({
            ...base,
            color: '#adb5bd',
            height: "46px",
            margin: '0px',
            padding: '0px !important',

        }),
        menu: (base) => ({
            ...base,
            backgroundColor: '#fff',
        }),
        option: (base, state) => ({
            ...base,
            color: state.isSelected ? '#3a5a6c' : null,
            backgroundColor: state.isFocused ? '#27485b73' : null,
            "&:active": {
                backgroundColor: "#27485b73"
            },
        }),
    };

    return (
        <>
            <section className="w-100 mt-3">
                <div className="card border-0 shadow-sm mb-3">
                    <div className="card-body p-3">
                        <div className="row">
                            {search !== false && (
                                <div className="col-md-6 mb-2 mb-md-0">
                                    <label className="form-label text-primary fw-medium small mb-1">Pesquisa</label>
                                    <div className="inner-addon right-addon">
                                        <i className="d-flex bi bi-search" />
                                        <input
                                            value={globalFilter || ""}
                                            onChange={e => setGlobalFilter(e.target.value)} type="search"
                                            placeholder="Pesquise o aluno pelo nome ou matrícula..."
                                            className="form-control py-2"
                                        />
                                    </div>
                                </div>
                            )}
                            <div className={`col-md-${search !== false ? '6' : '12'}`}>
                                <div className="row">
                                    <div className="col-md-8 mb-2 mb-md-0">
                                        <label className="form-label text-primary fw-medium small mb-1">Curso</label>
                                        <Select
                                            options={filterSelect.map((value) => {
                                                return {
                                                    value: value.id,
                                                    label: `${value.nome}`,
                                                };
                                            })}
                                            styles={customStyles}
                                            placeholder="Selecione o curso desejado"
                                            onChange={(selectedOption) => {
                                                setSelectCurso(selectedOption ? selectedOption.value : null);
                                            }}
                                            isClearable
                                        />
                                    </div>
                                    <div className="col-md-4 mb-2 mb-md-0">
                                        <label className="form-label text-primary fw-medium small mb-1">Registros por página</label>
                                        <select className="form-select py-2" value={pageSize} onChange={e => { setPageSize(Number(e.target.value)) }}>
                                            {[20, 50, 100, 500, 1000].map(pageSize => (
                                                <option key={pageSize} value={pageSize}>
                                                    {pageSize}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {(filterTipo || (unidades && unidades.length > 0) || (empresas && empresas.length > 0)) && (
                            <div className="row mt-2">
                                {filterTipo && (
                                    <div className={`col-md-${(unidades && unidades.length > 0) && empresas && empresas.length > 0 ? '4' : (unidades && unidades.length > 0) || (empresas && empresas.length > 0) ? '6' : '12'} mb-2 mb-md-0`}>
                                        <label className="form-label text-primary fw-medium small mb-1">Tipo</label>
                                        <Select
                                            options={filterTipo.map((value) => {
                                                return {
                                                    value: value.value,
                                                    label: `${value.label}`,
                                                };
                                            })}
                                            defaultValue={{ value: filterTipo[0].value, label: filterTipo[0].label }}
                                            styles={customStyles}
                                            placeholder="Filtro"
                                            onChange={(selectedOption) => {
                                                setSelectedTipo(selectedOption ? selectedOption.value : null);
                                            }}
                                        />
                                    </div>
                                )}
                                {unidades && unidades.length > 0 && (
                                    <div className={`col-md-${filterTipo && empresas && empresas.length > 0 ? '4' : filterTipo || (empresas && empresas.length > 0) ? '6' : '12'} mb-2 mb-md-0`}>
                                        <label className="form-label text-primary fw-medium small mb-1">Unidade</label>
                                        <Select
                                            options={unidades}
                                            styles={customStyles}
                                            placeholder="Selecione a unidade"
                                            onChange={(selectedOption) => {
                                                setSelectUnidade(selectedOption ? selectedOption.value : null);
                                            }}
                                            isClearable
                                        />
                                    </div>
                                )}
                                {empresas && empresas.length > 0 && setSelectedEmpresa && (
                                    <div className={`col-md-${filterTipo && unidades ? '4' : filterTipo || unidades ? '6' : '12'} mb-2 mb-md-0`}>
                                        <label className="form-label text-primary fw-medium small mb-1">Empresa</label>
                                        <Select
                                            options={[
                                                { value: null, label: 'Todas as empresas' },
                                                ...empresas.map((empresa) => ({
                                                    value: empresa.id,
                                                    label: empresa.titulo,
                                                }))
                                            ]}
                                            value={selectedEmpresa}
                                            styles={customStyles}
                                            placeholder="Selecione a empresa"
                                            isClearable
                                            onChange={(selectedOption) => {
                                                setSelectedEmpresa(selectedOption);
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </section>
            <div className="table-full-width mt-3 mb-3">
                <div className="table-responsive">
                    <table className="table align-middle mt-1 table-striped table-hover">
                        <thead>
                            <tr>
                                <th colSpan="8" className='bg-primary text-white rounded-top'>{titulo}</th>
                            </tr>
                        </thead>
                        <thead>
                            <tr className='border border-white'>
                                <th className='bg-muted'></th>
                                {search === true && <th className='text-uppercase text-black-50 fw-medium fs-8 bg-muted'>Aluno</th>}
                                <th className='text-uppercase text-black-50 fw-medium fs-8 bg-muted text-center'>Empresa</th>
                                <th className='text-uppercase text-black-50 fw-medium fs-8 bg-muted'>Curso</th>
                                <th className='text-uppercase text-black-50 fw-medium fs-8 bg-muted'>Gestor</th>
                                <th className='text-uppercase text-black-50 fw-medium fs-8 bg-muted text-center'>Data</th>
                                <th className='text-uppercase text-black-50 fw-medium fs-8 bg-muted text-center'>Status</th>
                                <th className='text-uppercase text-black-50 fw-medium fs-8 bg-muted text-center'>Download</th>
                            </tr>
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map((row, i) => {
                                prepareRow(row);
                                return (
                                    <tr {...row.getRowProps()}>
                                        {row.cells.map(cell => {
                                            
                                            return (
                                                <td className={`${cell.column.visible === false ? "d-none" : ""}`} {...cell.getCellProps()}>
                                                    {cell.render("Cell")}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colSpan="8" className='bg-primary text-white rounded-bottom'>
                                    <div className="table-footer d-flex justify-content-between align-items-center">
                                        <span>Exibindo {pageSize < rows.length ? pageSize : rows.length} de {rows.length} registros</span>
                                        <div>
                                            <span>Página {pageIndex + 1} de {pageOptions.length}</span>
                                            <button className="btn btn-primary btn-sm ms-2 text-white" onClick={() => previousPage()} disabled={!canPreviousPage}>
                                                <i className="bi bi-caret-left"></i>
                                            </button>
                                            <button className="btn btn-primary btn-sm ms-1 text-white" onClick={() => nextPage()} disabled={!canNextPage}>
                                                <i className="bi bi-caret-right"></i>
                                            </button>
                                        </div>
                                    </div>
                                </th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </>
    )

}
export default TableCertificado;